import React, { PropsWithChildren } from "react";
import Navbar from "../components/navbar/navbar";
import Footer from "../components/footer/footer";
import TrustMe from "../modules/trust-me/trust-me";

const MainLayout = ({ children }: PropsWithChildren) => {
  return (
    <div className="w-full mx-auto laptop:max-w-[1302px] desktop:max-w-[1440px] overflow-x-hidden laptop:overflow-x-visible">
      <Navbar />
      {children}
      <TrustMe />
      <Footer />
    </div>
  );
};

export default MainLayout;
